import { associationIdName, siteNumber, fetchGet } from "./common";
import { stripHtml } from "../lib/stripHtml";

export class BlogPost {
    alert!: string;
    author!: string;
    headline!: string;
    id!: number;
    imageUrl!: string | null;
    publicationDate!: string;
    shortenedAlert!: string;

    constructor(data: BlogPost) {
        Object.assign(this, data);
        this.shortenedAlert = stripHtml(data.shortenedAlert || data.alert || "");
    }

    getDisplayedPublicationDate(): string {
        return new Date(this.publicationDate).toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    }
}

export const getBlogPosts = async (): Promise<BlogPost[]> => {
    const url = `blogposts?association=${associationIdName}&sitenumber=${siteNumber}`;
    const response = await fetchGet<BlogPost[]>(url);
    return response.map((data) => new BlogPost(data));
};

export const getBlogPost = async (id: number): Promise<BlogPost> => {
    const url = `blogposts/${id}?association=${associationIdName}`;
    const response = await fetchGet<BlogPost>(url);
    return new BlogPost(response);
};
